
import styled from 'styled-components';

const Input = styled.input`
  color: ${props => props.color || props.theme.color.primary};
  background-color: ${props => props.backgroundColor || props.theme.color.softGray};  
  border: 1px solid rgb(201, 205, 209);
  border-radius: 6px;
  margin-top: 5px;
  outline: none;
`;

export default Input;